/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetSupplementStats200Response
 */
export interface GetSupplementStats200Response {
    /**
     * Total number of supplements
     * @type {number}
     * @memberof GetSupplementStats200Response
     */
    totalSupplements?: number;
    /**
     * Number of supplements in draft status
     * @type {number}
     * @memberof GetSupplementStats200Response
     */
    draftSupplements?: number;
    /**
     * Number of submitted supplements
     * @type {number}
     * @memberof GetSupplementStats200Response
     */
    submittedSupplements?: number;
    /**
     * Number of approved supplements
     * @type {number}
     * @memberof GetSupplementStats200Response
     */
    approvedSupplements?: number;
    /**
     * Number of rejected supplements
     * @type {number}
     * @memberof GetSupplementStats200Response
     */
    rejectedSupplements?: number;
}

/**
 * Check if a given object implements the GetSupplementStats200Response interface.
 */
export function instanceOfGetSupplementStats200Response(value: object): value is GetSupplementStats200Response {
    return true;
}

export function GetSupplementStats200ResponseFromJSON(json: any): GetSupplementStats200Response {
    return GetSupplementStats200ResponseFromJSONTyped(json, false);
}

export function GetSupplementStats200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSupplementStats200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'totalSupplements': json['totalSupplements'] == null ? undefined : json['totalSupplements'],
        'draftSupplements': json['draftSupplements'] == null ? undefined : json['draftSupplements'],
        'submittedSupplements': json['submittedSupplements'] == null ? undefined : json['submittedSupplements'],
        'approvedSupplements': json['approvedSupplements'] == null ? undefined : json['approvedSupplements'],
        'rejectedSupplements': json['rejectedSupplements'] == null ? undefined : json['rejectedSupplements'],
    };
}

export function GetSupplementStats200ResponseToJSON(json: any): GetSupplementStats200Response {
    return GetSupplementStats200ResponseToJSONTyped(json, false);
}

export function GetSupplementStats200ResponseToJSONTyped(value?: GetSupplementStats200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalSupplements': value['totalSupplements'],
        'draftSupplements': value['draftSupplements'],
        'submittedSupplements': value['submittedSupplements'],
        'approvedSupplements': value['approvedSupplements'],
        'rejectedSupplements': value['rejectedSupplements'],
    };
}

